const inputMetre = document.querySelector(".size-input-metre");
const inputFeet = document.querySelector(".size-input-feet");
const result = document.querySelector(".result");
// const distance = document.querySelector(".distance");
const calcButton = document.querySelector(".calc-button");
const speakerErrorMessage = document.querySelector(".speaker-error-message");
const inputErrorMessage = document.querySelector(".input-error-message");
const valueErrorMessage = document.querySelector(".input-value-error-message");
const calcResult = document.querySelector(".calc-result");
const resultSection = document.querySelector(".result-section");
const inputs = document.querySelectorAll("input");
const resultTextAlt = document.querySelector(".result-text-alt");
const contactUsText = document.querySelector(".contact-us-text");

const wallSpkBtn = document.querySelector(".wall-speakers-button");
const ceilingSpkBtn = document.querySelector(".ceiling-speakers-button");
const pendantSpkBtn = document.querySelector(".pendant-speakers-button");
const hornSpkBtn = document.querySelector(".horn-speakers-button");

function speakerError() {
    [wallSpkBtn.classList.add("error"),
    ceilingSpkBtn.classList.add("error"),
    pendantSpkBtn.classList.add("error"),
    hornSpkBtn.classList.add("error")]
}

function removeSpeakerError() {
    [wallSpkBtn.classList.remove("error"),
    ceilingSpkBtn.classList.remove("error"),
    pendantSpkBtn.classList.remove("error"),
    hornSpkBtn.classList.remove("error")]
}

// const footConvertBtn = ;

// const inputValue = input.value;
// const inputFtConvert = input.value * 0.3048;

inputFeet.addEventListener('input', function () {
    inputMetre.value = (this.value * 0.3048).toFixed(2);
});

inputMetre.addEventListener('input', function () {
    inputFeet.value = (this.value * 3.28084).toFixed(2);
});

wallSpkBtn.addEventListener("click", () => {

    wallSpkBtn.classList.toggle("active");

    ceilingSpkBtn.classList.remove("active");
    pendantSpkBtn.classList.remove("active");
    hornSpkBtn.classList.remove("active");

    removeSpeakerError();
    speakerErrorMessage.classList.remove("active");

    if (!wallSpkBtn.classList.contains("active")) {
        result.innerHTML = "";
        // distance.innerHTML = "";
    }
});

ceilingSpkBtn.addEventListener("click", () => {

    ceilingSpkBtn.classList.toggle("active");

    wallSpkBtn.classList.remove("active");
    pendantSpkBtn.classList.remove("active");
    hornSpkBtn.classList.remove("active");

    removeSpeakerError();
    speakerErrorMessage.classList.remove("active");

    if (!ceilingSpkBtn.classList.contains("active")) {
        result.innerHTML = "";
        // distance.innerHTML = "";
    }
});

pendantSpkBtn.addEventListener("click", () => {

    pendantSpkBtn.classList.toggle("active");

    ceilingSpkBtn.classList.remove("active");
    wallSpkBtn.classList.remove("active");
    hornSpkBtn.classList.remove("active");

    removeSpeakerError();
    speakerErrorMessage.classList.remove("active");

    if (!pendantSpkBtn.classList.contains("active")) {
        result.innerHTML = "";
        // distance.innerHTML = "";
    }
});

hornSpkBtn.addEventListener("click", () => {

    hornSpkBtn.classList.toggle("active");

    ceilingSpkBtn.classList.remove("active");
    pendantSpkBtn.classList.remove("active");
    wallSpkBtn.classList.remove("active");

    removeSpeakerError();
    speakerErrorMessage.classList.remove("active");

    if (!hornSpkBtn.classList.contains("active")) {
        result.innerHTML = "";
        // distance.innerHTML = "";
    }
});


calcButton.addEventListener("click", () => {

    if (!wallSpkBtn.classList.contains("active") && !ceilingSpkBtn.classList.contains("active") && !pendantSpkBtn.classList.contains("active") && !hornSpkBtn.classList.contains("active")) {
        speakerError();
        speakerErrorMessage.classList.add("active");
        
    }


  if (inputMetre.value <= 0) {
          valueErrorMessage.classList.add("active");
        } else {
          valueErrorMessage.classList.remove("active");
        }


    if (wallSpkBtn.classList.contains("active") && !inputMetre.value == "") {

        if (inputMetre.value >= 0. && inputMetre.value <= 24){
          result.innerHTML = "1";
            contactUsText.innerHTML = "";
          
        } else if (inputMetre.value >= 25 && inputMetre.value <= 49) {
            result.innerHTML = "2-4";
            contactUsText.innerHTML = "";
        
        } else if (inputMetre.value >= 50 && inputMetre.value <= 99) {
            result.innerHTML = "4-6";
            contactUsText.innerHTML = "";

        } else if (inputMetre.value >= 100 && inputMetre.value <= 214) {
            result.innerHTML = "6-8";
            contactUsText.innerHTML = "";

        } else if (inputMetre.value >= 215 && inputMetre.value <= 399) {
            result.innerHTML = "8-10";
            contactUsText.innerHTML = "";

        } else if (inputMetre.value >= 400 && inputMetre.value <= 624) {
            result.innerHTML = "10-12";
            contactUsText.innerHTML = "";

        } else if (inputMetre.value >= 625 && inputMetre.value <= 899) {
            result.innerHTML = "12-14";
            contactUsText.innerHTML = "For an area of this size we recommend you get in touch for further assistance.";

        } else if (inputMetre.value >= 900 && inputMetre.value <= 1599) {
            result.innerHTML = "16-18";
            contactUsText.innerHTML = "For an area of this size we recommend you get in touch for further assistance.";

        } else {
            result.innerHTML = "20+";
            contactUsText.innerHTML = "For an area of this size we recommend you get in touch for further assistance.";
        };

        // distance.innerHTML = "5-7m"
    };

    if (ceilingSpkBtn.classList.contains("active") && !inputMetre.value == "") {

        if (inputMetre.value >= 0.30 && inputMetre.value <= 24){
            result.innerHTML = "1";
            contactUsText.innerHTML = "";
          
        } else if (inputMetre.value >= 25 && inputMetre.value <= 49) {
            result.innerHTML = "2-4";
            contactUsText.innerHTML = "";
        
        } else if (inputMetre.value >= 50 && inputMetre.value <= 99) {
            result.innerHTML = "4-6";
            contactUsText.innerHTML = "";

        } else if (inputMetre.value >= 100 && inputMetre.value <= 214) {
            result.innerHTML = "6-8";
            contactUsText.innerHTML = "";

        } else if (inputMetre.value >= 215 && inputMetre.value <= 399) {
            result.innerHTML = "8-10";
            contactUsText.innerHTML = "";

        } else if (inputMetre.value >= 400 && inputMetre.value <= 624) {
            result.innerHTML = "10-12";
            contactUsText.innerHTML = "";

        } else if (inputMetre.value >= 625 && inputMetre.value <= 899) {
            result.innerHTML = "12-14";
            contactUsText.innerHTML = "For an area of this size we recommend you get in touch for further assistance.";

        } else if (inputMetre.value >= 900 && inputMetre.value <= 1599) {
            result.innerHTML = "16-18";
            contactUsText.innerHTML = "For an area of this size we recommend you get in touch for further assistance.";

        } else {
            result.innerHTML = "20+";
            contactUsText.innerHTML = "For an area of this size we recommend you get in touch for further assistance.";
        };

        // distance.innerHTML = "5-7m"
    };

    if (pendantSpkBtn.classList.contains("active") && !inputMetre.value == "") {

        
        if (inputMetre.value >= 0.30 && inputMetre.value <= 24){
          result.innerHTML = "1";
            contactUsText.innerHTML = "";
          
        } else if (inputMetre.value >= 25 && inputMetre.value <= 214) {
            result.innerHTML = "1-2";
            contactUsText.innerHTML = "";

        } else if (inputMetre.value >= 215 && inputMetre.value <= 899) {
            result.innerHTML = "4";
            contactUsText.innerHTML = "";

        } else if (inputMetre.value >= 900 && inputMetre.value <= 1299) {
            result.innerHTML = "4-6";
            contactUsText.innerHTML = "";

        } else if (inputMetre.value >= 1300 && inputMetre.value <= 1599) {
            result.innerHTML = "8-9";
            contactUsText.innerHTML = "";

        } else if (inputMetre.value >= 1600 && inputMetre.value <= 2499) {
            result.innerHTML = "9-10";
            contactUsText.innerHTML = "For an area of this size we recommend you get in touch for further assistance.";

        } else if (inputMetre.value >= 2500 && inputMetre.value <= 3599) {
            result.innerHTML = "10-12";
            contactUsText.innerHTML = "For an area of this size we recommend you get in touch for further assistance.";

        } else {
            result.innerHTML = "14+";
            contactUsText.innerHTML = "For an area of this size we recommend you get in touch for further assistance.";
        };

        // distance.innerHTML = "10-15m"
    };

    if (hornSpkBtn.classList.contains("active") && !inputMetre.value == "") {

       if (inputMetre.value >= 0.30 && inputMetre.value <= 24){
            result.innerHTML = "1";
            contactUsText.innerHTML = "";
          
        } else if (inputMetre.value >= 25 && inputMetre.value <= 214) {
            result.innerHTML = "1-2";
            contactUsText.innerHTML = "";

        } else if (inputMetre.value >= 215 && inputMetre.value <= 899) {
            result.innerHTML = "4";
            contactUsText.innerHTML = "";

        } else if (inputMetre.value >= 900 && inputMetre.value <= 1299) {
            result.innerHTML = "4-6";
            contactUsText.innerHTML = "";

        } else if (inputMetre.value >= 1300 && inputMetre.value <= 1599) {
            result.innerHTML = "8-9";
            contactUsText.innerHTML = "";

        } else if (inputMetre.value >= 1600 && inputMetre.value <= 2499) {
            result.innerHTML = "9-10";
            contactUsText.innerHTML = "For an area of this size we recommend you get in touch for further assistance.";

        } else if (inputMetre.value >= 2500 && inputMetre.value <= 3599) {
            result.innerHTML = "10-12";
            contactUsText.innerHTML = "For an area of this size we recommend you get in touch for further assistance.";

        } else {
            result.innerHTML = "14+";
            contactUsText.innerHTML = "For an area of this size we recommend you get in touch for further assistance.";
        };


        // distance.innerHTML = "10-15m"
    };

    
    if (result.innerHTML == ""){
        resultTextAlt.classList.remove("active");
        resultSection.classList.remove("active");
    } else {
        resultTextAlt.classList.add("active");

        resultSection.classList.add("active");    }

    calcResult.innerHTML = result.innerHTML;

});

const accordion = document.getElementsByClassName("accordion");
let k;

for (k = 0; k < accordion.length; k++) {
    accordion[k].addEventListener("click", function () {
        this.classList.toggle("active");
        const panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";

        }
    })
}

